'use client';
import { LimitedQueue } from './LimitedQueue/LimitedQueue.js';

const EventDeferrer = (options)=>{
    const { bus, limit = 128 } = options;
    const deferrer = {
        enqueue,
        eject,
        dispatchDeferredEvents,
        hasLimitedQueueFor,
        getQueueLength
    };
    const queues = new Map();
    function enqueue({ id }, eventName, payload) {
        var _queues_get;
        if (!queues.has(id)) {
            queues.set(id, LimitedQueue({
                limit
            }));
        }
        (_queues_get = queues.get(id)) == null ? void 0 : _queues_get.push({
            id: eventName,
            payload
        });
        bus.emit('event-enqueued', id, String(eventName));
    }
    function hasLimitedQueueFor({ id }) {
        return queues.has(id);
    }
    function getQueueLength({ id }) {
        var _queues_get;
        return (_queues_get = queues.get(id)) == null ? void 0 : _queues_get.getLength();
    }
    function eject({ id }) {
        queues.delete(id);
        bus.emit('plugin-ejected', id);
    }
    function dispatchDeferredEvents(plugin) {
        const { id, onEventEmitted } = plugin;
        const queue = queues.get(id);
        if (queue) {
            const intervalId = setInterval(()=>{
                if (queue.isEmpty()) {
                    clearInterval(intervalId);
                    eject(plugin);
                    return;
                }
                const event = queue.shift();
                if (event) {
                    onEventEmitted(event.id, event.payload);
                    bus.emit('queued-event-dispatched', id);
                }
            }, 300);
        }
    }
    return deferrer;
};

export { EventDeferrer };
//# sourceMappingURL=EventDeferrer.js.map
